import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-gallery-items-load-more',
  templateUrl: './gallery-items-load-more.component.html',
  styleUrls: ['./gallery-items-load-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryItemsLoadMoreComponent {
  @Output()
  loadMore: EventEmitter<void> = new EventEmitter();

  protected onLoadMore(): void {
    this.loadMore.emit();
  }
}
